// extracted by mini-css-extract-plugin
export default {"logo":"header_logo__f7ctx","header":"header_header__OuCq3","container":"header_container__W2ewr","logoLink":"header_logoLink__kTAXJ"};